<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="项目名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['name', validatorRules.name]" placeholder="请输入项目名"></a-input>
        </a-form-item>
        <a-form-item label="项目经理" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input @click="selectProjectManager" v-decorator="['manager', validatorRules.manager]" placeholder="请输入项目经理"></a-input>
        </a-form-item>
        <!-- <a-form-item label="受益部门编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-select-depart v-decorator="['departNum', validatorRules.departNum]" :trigger-change="true" />
        </a-form-item> -->
        <a-form-item label="预计开始时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date
            placeholder="请选择预计开始时间"
            v-decorator="['startTime', validatorRules.startTime]"
            :trigger-change="true"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item label="预计结束时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date
            placeholder="请选择预计结束时间"
            v-decorator="['endTime', validatorRules.endTime]"
            :trigger-change="true"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item label="战略层级" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            type="list"
            v-decorator="['level', validatorRules.level]"
            @change="handleStrategicLevelChange"
            :trigger-change="true"
            dictCode="project_daily_strategic_level"
            placeholder="请选择战略层级"
          />
        </a-form-item>
        <a-form-item label="战略层级系数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            v-decorator="['levelCoefficient', validatorRules.levelCoefficient]"
            placeholder="自动带出"
            style="width: 100%"
            readonly
          />
        </a-form-item>
        <a-form-item label="难度系数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            v-decorator="['courseRat', validatorRules.courseRat]"
            placeholder="请输入难度系数"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item label="基础分" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number disabled
            v-decorator="['baseScore',  {initialValue:100}]"
            style="width: 100%"
          />
        </a-form-item>
        <!-- <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remark', validatorRules.remark]" placeholder="请输入备注"></a-input>
        </a-form-item> -->
        <a-form-item v-show="false" label="是否完工" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['compleState']" placeholder="请输入项目名"></a-input-number>
        </a-form-item>
      </a-form>
    </a-spin>
    <select-lead-modal ref="SelectLeadModal" :onlySelectOne="true" @selectChoosed="selectleadOK"></select-lead-modal>
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JDate from '@/components/jeecg/JDate'
import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import SelectLeadModal from './SelectLeadModal'
import {getDailyConfigList} from '@/api/api.js'
import moment from 'moment'

export default {
  name: 'BusDailyProjectModal',
  components: {
    JDate,
    JSelectDepart,
    JSelectUserByDep,
    JDictSelectTag,
    SelectLeadModal,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        manager: { rules: [{ required: true, message: '请输入项目经理' }] },
        startTime: { rules: [{ required: true, message: '请选择预计开始时间' }] },
        endTime: { rules: [{ required: true, message: '请选择预计结束时间' }] },
        name: { rules: [{ required: true, message: '请输入项目名' },{ validator: (rule, value, callback) => validateDuplicateValue('bus_daily_project', 'name', value, this.model.id, callback)}] },
        level: { rules: [{ required: true, message: '请选择战略层级' }] },
        levelCoefficient: { rules: [{ required: true, message: '请输入战略层级系数' }] },
        courseRat: { rules: [{ required: true, message: '请输入难度系数' }] },
      },
      url: {
        add: '/dailyproject/busDailyProject/add',
        edit: '/dailyproject/busDailyProject/edit',
      },
      strategicCoefficientList:[]
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({compleState:1})
    },
    edit(record) {
      this.visible = true
      // 先获取配置项，获取战略层级和战略系数的关系
      this.confirmLoading=true;
      getDailyConfigList("strategic_coefficient").then((res)=>{
        if(res.code===200){
          // 存配置项
          this.strategicCoefficientList=res.result.records
          this.form.resetFields()
          this.model = Object.assign({}, record)
          this.$nextTick(() => {
            this.form.setFieldsValue(
              pick(
                this.model,
                'manager',
                'createTime',
                'endTime',
                'remark',
                'createBy',
                'startTime',
                'outstandScore',
                'compleState',
                'name',
                'totalScore',
                'level',
                'levelCoefficient',
                'courseRat',
                'baseScore'
              )
            )
          })
        }else{
          this.$message.error("获取日报配置项出错"+res.message)
        }
      }).catch((err)=>{
        if(err.message){
          this.$message.error("获取日报配置项出错"+err.message)
        }else{
          this.$message.error("获取日报配置项出错"+err)
        }
      }).finally(()=>{
        this.confirmLoading=false;
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    //选择项目经理
    selectProjectManager() {
      this.$refs.SelectLeadModal.add()
    },
    selectleadOK(selectData) {
      this.form.setFieldsValue({
        manager: selectData[0].username,
      })
    },
    handleOk() {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          if(moment(values.endTime).isBefore(values.startTime) || moment(values.endTime).isSame(values.startTime)){
            this.$message.error("结束时间不得大于等于开始时间")
            return
          }
          this.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'post'
          }
          let formData = Object.assign(this.model, values)
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                this.$message.success(res.message)
                this.$emit('ok')
              } else {
                this.$message.warning(res.message)
              }
            })
            .finally(() => {
              this.confirmLoading = false
              this.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'manager',
          'createTime',
          'endTime',
          'remark',
          'createBy',
          'startTime',
          'outstandScore',
          'compleState',
          'name',
          'totalScore',
          'level',
          'levelCoefficient',
          'courseRat',
          'baseScore'
        )
      )
    },
    handleStrategicLevelChange(newVal){
      // 自动带出公司战略层级系数
      try {
        let isGetValue = this.strategicCoefficientList.some(item=>{
          if(item.configKey===newVal){
            this.$nextTick(()=>{
              this.form.setFieldsValue({
                levelCoefficient:parseFloat(item.configValue)
              })
            })
            return true
          }
          return false
        })
        console.log(isGetValue)
        if(!isGetValue){
         this.$nextTick(()=>{
            this.form.setFieldsValue({
              levelCoefficient:""
            })
         })
        }
      } catch (err) {
        console.log(err)
        this.$message.error(err.message)
        this.$nextTick(()=>{
          this.form.setFieldsValue({
            levelCoefficient:""
          })
        })
      }
    }
  },
}
</script>